import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withApollo } from "react-apollo";
import React from "react";

import { findRoleById } from "../../../services/graphql/queries/roles";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import RolesView from "./RolesView";
import RolesEdit from "./RolesEdit";
import RolesDetails from "./RolesDetails";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
import queryString from "query-string";

class RolesProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      error: "",
      user: {},
      userDetails: {},
      editMode: false,
      isCreated: false,
      accessSpecifier: {},
      Roles_Feature_ID: 172,
      Roles_Privilege_Feature_ID: 173,
      Roles_Module_ID: 6
    };

    this.onUpdateUser = this.onUpdateUser.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.fetchAccessSpecifier = this.fetchAccessSpecifier.bind(this);
    this.getRolesById = this.getRolesById.bind(this);
  }

  toggleEditMode(mode) {
    this.setState({ editMode: mode });
  }

  onUpdateUser(userDetails) {
    // console.log("user data",userDetails)
    this.setState({ userDetails });
    this.setState({ loading: true });

    this.props.client
      .query({
        query: findRoleById,
        variables: { id: queryString.parse(this.props.location.search).id },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const user = result.data.findRoleById;

        this.initialState = {
          user: user
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.findRoleById);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  getRolesById() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: findRoleById,
        variables: { id: queryString.parse(this.props.location.search).id },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const user = result.data.findRoleById;

        this.initialState = {
          user: user
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.findRoleById);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
    this.setState({
      isCreated: queryString.parse(this.props.location.search).success
        ? true
        : false
    });
    setTimeout(() => {
      this.setState({ isCreated: false });
    }, SET_TIMEOUT_VALUE);
  }
  fetchAccessSpecifier() {
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.Roles_Module_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState(
            {
              accessSpecifier: response
            },
            () => {
              this.getRolesById();
            }
          );
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }
  componentDidMount() {
    this.fetchAccessSpecifier();
  }

  render() {
    const {
      loading,
      error,
      user,
      isCreated,
      accessSpecifier,
      Roles_Privilege_Feature_ID
    } = this.state;

    if (error) return <div>{error}</div>;
    if (loading) return <div>Fetching...</div>;
    return (
      <>
        {Object.keys(this.state.user).length &&
        Object.keys(this.state.accessSpecifier).length ? (
          <>
            {this.state.editMode ? (
              <RolesEdit
                user={user}
                toggleEditMode={this.toggleEditMode}
                onUpdateUser={this.onUpdateUser}
              />
            ) : (
              <RolesView
                user={user}
                toggleEditMode={this.toggleEditMode}
                userDetails={this.state.userDetails}
                isCreated={isCreated}
                accessSpecifier={accessSpecifier}
              />
            )}
            {accessSpecifier[Roles_Privilege_Feature_ID] &&
            accessSpecifier[Roles_Privilege_Feature_ID].viewP ? (
              <RolesDetails user={user} accessSpecifier={accessSpecifier} />
            ) : null}
          </>
        ) : (
          <div>Fetching...</div>
        )}
      </>
    );
  }
}

RolesProfile.getInitialProps = ({ router }) => {
  return { router };
};

export default withRouter(connect()(withApollo(RolesProfile)));
